import {
  COOKIE_JWT,
  COOKIE_MAGNIT_CODE,
  COOKIE_KFP_TOKEN,
  COOKIE_MAX_AGE,
  COOKIE_PROFILE_INCOMPLETE,
} from "@magnit/util-auth/src/constants";
import { useRequestURL, useRuntimeConfig, useCookie, useState } from "nuxt/app";
import { computed } from "vue";
import type { IProfileIncompleteCookieValue } from "../typings/cookies";

export default () => {
  const { hostname } = useRequestURL();
  const { public: publicConfig } = useRuntimeConfig();

  const UAT_MARKER = "uat";
  const DEV_MARKER = "dev";
  const localhosts = ["localhost", "127.0.0.1"];
  const getCookieDomain = (hostname: string) =>
    !localhosts.includes(hostname)
      ? hostname.includes(UAT_MARKER)
        ? `.${UAT_MARKER}${hostname.split(UAT_MARKER)[1]}`
        : hostname.includes(DEV_MARKER)
          ? `.${DEV_MARKER}${hostname.split(DEV_MARKER)[1]}`
          : `.${hostname.split(".").slice(-2).join(".")}`
      : hostname;

  const domain = (publicConfig.cookieDomain as string) || getCookieDomain(hostname);
  // useState остаётся реактивным между слоями, чистый useCookie теряет реактивность
  // [TO DO] придумать более элегантное решение
  const _cookieJWT = useCookie<{ access: string; refresh: string; } | null>(COOKIE_JWT, {
    domain,
    default: () => null,
    maxAge: COOKIE_MAX_AGE,
    watch: true,
  });
  const stateJWT = useState(`state-${COOKIE_JWT}`, () => _cookieJWT.value);
  const cookieJWT = computed({
    get: () => stateJWT.value,
    set: (v: null | { access: string; refresh: string; }) => {
      stateJWT.value = v;
      _cookieJWT.value = v;
    },
  });

  const _cookieKFP = useCookie<string | null>(COOKIE_KFP_TOKEN, {
    default: () => null,
    maxAge: COOKIE_MAX_AGE,
  });
  const stateKfp = useState(`state-${COOKIE_KFP_TOKEN}`, () => _cookieKFP.value);
  const cookieKFP = computed({
    get: () => stateKfp.value,
    set: (v: null | string) => {
      stateKfp.value = v;
      _cookieKFP.value = v;
    },
  });

  const _cookieMagnitCode = useCookie<string | null>(COOKIE_MAGNIT_CODE, {
    default: () => null,
    maxAge: COOKIE_MAX_AGE,
  });
  const stateMagnitCode = useState(`state-${COOKIE_MAGNIT_CODE}`, () => _cookieMagnitCode.value);
  const cookieMagnitCode = computed({
    get: () => stateMagnitCode.value,
    set: (v: null | string) => {
      stateMagnitCode.value = v;
      _cookieMagnitCode.value = v;
    },
  });

  const _cookieProfileIncomplete = useCookie<IProfileIncompleteCookieValue | null>(COOKIE_PROFILE_INCOMPLETE, {
    default: () => null,
    maxAge: COOKIE_MAX_AGE,
  });
  const stateProfileIncompleteCode = useState(`state-${COOKIE_PROFILE_INCOMPLETE}`, () => _cookieProfileIncomplete.value);
  const profileIncompleteState = computed({
    get: () => stateProfileIncompleteCode.value,
    set: (v: null | IProfileIncompleteCookieValue): void => {
      stateProfileIncompleteCode.value = v;
      _cookieProfileIncomplete.value = v;
    },
  });

  const accessToken = computed(() => cookieJWT.value?.access);
  const refreshToken = computed(() => cookieJWT.value?.refresh);

  return {
    cookieJWT,
    cookieKFP,
    cookieMagnitCode,
    accessToken,
    refreshToken,
    getCookieDomain,
    profileIncompleteState,
  };
};
